import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { get as lodashGet } from 'lodash-es';
import { CachedTranslations } from '@interfaces';
import { AvailableLanguages } from '@constants';

@Injectable({
  providedIn: 'root',
})
export class TranslateUtilsService {
  constructor(private readonly translateService: TranslateService) {
    this.availableLangs = translateService.getLangs() as AvailableLanguages[];
  }

  private translationsObject: CachedTranslations;
  private availableLangs: AvailableLanguages[];

  private async loadTranslationFile(lang: string, namespace?: string): Promise<any> {
    const path = namespace ? `assets/i18n/${namespace}/${lang}.json` : `assets/i18n/${lang}.json`;

    const response = await fetch(path);
    return await response.json();
  }

  public async saveNamespaceTranslations(namespace?: string, baseKey?: string): Promise<void> {
    this.translationsObject = {} as CachedTranslations;

    for (const langKey of this.availableLangs) {
      const translations = await this.loadTranslationFile(langKey, namespace);
      const scoped = baseKey ? lodashGet(translations, baseKey) : translations;

      this.translationsObject[langKey] = scoped ?? {};
    }
  }
  public getTranslations(key: string): { [key: string]: string } {
    const result: CachedTranslations = {} as CachedTranslations;

    this.availableLangs.forEach(language => {
      result[language] = lodashGet(this.translationsObject[language], key);
    });

    return result;
  }
}
